function ReportDetail() {
    return ( <>
    this is Report Detail Page
    </> );
}

export default ReportDetail;